import React, { useEffect } from "react";

import "./ThankYou.css";
import Button from "../../components/Button/Button";
import { Link } from "react-router-dom";

const ThankYou = () => {
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "Shreeyash Parsawar - Thank You | Portfolio";
  }, []);

  return (
    <section className="sectionThankYou  align-items-center ">
      <section className="mainThankyou">
        <div className="container-fluid text-center">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="thankYouText">Thank You</h1>

              <p className="ackText">
                Your message has been received, and I'll make it a priority to
                respond within the next 24 hours.
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 mt-3 text-center">
              <Link to="/project">
                <Button title="Explor Project" />
              </Link>
            </div>

            <div className="col-lg-6 col-md-6 mt-3 text-center">
              <Link to="/">
                <Button title="Go Back Home" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default ThankYou;
